import { useEffect, useReducer, useState } from "react";
import { Card, Typography } from "@mui/material";
import FormFooter from "../../../components/FormFooter";
import useFetch from "../../../hooks/useFetch";
import { CONTACTS_APIS } from "../../../common/apis";
import Form, { FormActions } from "../../../components/Form";
import { ValidateSchema } from "../../../validation/schemas/SecondaryContactsSchema";

export default function SecondaryContact({ contactId, cancel }) {

    const { get, post } = useFetch();

    const [data1, dispatch1] = useReducer(SearchFilterReducer, SearchFilterDefaults);
    const [data2, dispatch2] = useReducer(SearchFilterReducer, SearchFilterDefaults);
    const [data3, dispatch3] = useReducer(SearchFilterReducer, SearchFilterDefaults);
    const [data4, dispatch4] = useReducer(SearchFilterReducer, SearchFilterDefaults);
    const [infoObj, setInfoObj] = useState({});
    const [formErrors, setFormErrors] = useState({ form1: {}, form2: {}, form3: {}, form4: {} });

    useEffect(() => {
        (async function () {
            const contactData = await get(`${CONTACTS_APIS.CONTACT_ALTERNATIVE}?contactId=${contactId}`);
            (Object.entries(contactData[0])?.length > 0) && dispatch1({
                type: ContactActions.LOAD_DATA,
                payload: { ...contactData[0] },
            });
            (Object.entries(contactData[1])?.length > 0) && dispatch2({
                type: ContactActions.LOAD_DATA,
                payload: { ...contactData[1] },
            });
            (Object.entries(contactData[2])?.length > 0) && dispatch3({
                type: ContactActions.LOAD_DATA,
                payload: { ...contactData[2] },
            });
            (Object.entries(contactData[3])?.length > 0) && dispatch4({
                type: ContactActions.LOAD_DATA,
                payload: { ...contactData[3] },
            });
        })()
    }, []);

    const handleSave = async () => {
        setInfoObj({ message: "", color: "black" });
        setFormErrors({ form1: {}, form2: {}, form3: {}, form4: {} });

        const result1 = await ValidateSchema(data1);
        if (result1.errors) {
            setFormErrors({ form1: result1.errors });
            return; // Stop here if first validation fails
        }

        const result2 = await ValidateSchema(data2);
        if (result2.errors) {
            setFormErrors({ form2: result2.errors });
            return;
        }

        const result3 = await ValidateSchema(data3);
        if (result3.errors) {
            setFormErrors({ form3: result3.errors });
            return;
        }

        const result4 = await ValidateSchema(data4);
        if (result4.errors) {
            setFormErrors({ form4: result4.errors });
            return;
        }

        const resp = await post(CONTACTS_APIS.ADD_CONTACT_ALTERNATIVE, [
            { ...data1, Priority: parseInt(data1?.Priority), ContactId: contactId },
            { ...data2, Priority: parseInt(data2?.Priority), ContactId: contactId },
            { ...data3, Priority: parseInt(data3?.Priority), ContactId: contactId },
            { ...data4, Priority: parseInt(data4?.Priority), ContactId: contactId },
        ]
        );
        if (resp !== null && resp >= 0) {
            setInfoObj({ message: "" })
            cancel && cancel()
        }
        else {
            setInfoObj({ message: "Something went wrong!", color: "red" })
        }
    }

    return (
        <>
            <Card sx={{ p: 1 }}>
                <Typography mt={2} mb={1} sx={{ fontWeight: 800, color: (infoObj?.color || "black") }}>{infoObj?.message}</Typography>

                <Typography mt={2} mb={1} sx={{ fontWeight: 800 }}>Secondary 1</Typography>
                <Form
                    sections={FormSections(data1)}
                    data={data1}
                    dispatch={dispatch1}
                    errors={formErrors?.form1}
                    key={data1 && data1?.AlternativeId}
                />

                < Typography mt={2} mb={1} sx={{ fontWeight: 800 }}>Secondary 2</Typography>
                <Form
                    sections={FormSections(data2)}
                    data={data2}
                    dispatch={dispatch2}
                    errors={formErrors?.form2}
                    key={data2 && data2?.AlternativeId}
                />

                <Typography mt={2} mb={1} sx={{ fontWeight: 800 }}>Secondary 3</Typography>
                <Form
                    sections={FormSections(data3)}
                    data={data3}
                    dispatch={dispatch3}
                    errors={formErrors?.form3}
                    key={data3 && data3?.AlternativeId}
                />

                <Typography mt={2} mb={1} sx={{ fontWeight: 800 }}>Secondary 4</Typography>
                <Form
                    sections={FormSections(data4)}
                    data={data4}
                    dispatch={dispatch4}
                    errors={formErrors?.form4}
                    key={data4 && data4?.AlternativeId}
                />

                <Typography my={1} >AU +61 and 1 area code and 8 digits</Typography>
                <Typography my={1} >NZ Mobile +642 and 7 to 9 digits &ensp; &emsp; NZ +64 and 1 area code and 7 digits</Typography>
                <Typography my={1} >NC +687 and 6 digits</Typography>
                <Typography my={1} >Secondary 4</Typography>

                <FormFooter footerText={`ContactId: ${contactId || ""}`} buttons={GetFormButtons(handleSave)} />
            </Card>
        </>
    );
}

const GetFormButtons = (handleSave) => [
    { variant: "contained", label: "Save", onClick: handleSave },
];

const FormSections = (data) => [
    {
        xsCol: 12,
        fields: [
            { name: "Forename", label: "Forename", xsCol: 3 },
            { name: "Surname", label: "Surname", xsCol: 3 },
            { name: "Mobile", label: "Mobile", xsCol: 3 },
            { name: "Telephone", label: "Telephone", xsCol: 3 },
            { name: "Position", label: "Position", xsCol: 6 },
            { name: "Priority", label: "Priority", xsCol: 2, type: "number", min: 1, max: 9 },
            { name: "IsDeleted", label: "Delete", xsCol: 1, type: "switch", disabled: !(data?.AlternativeId > 0) },
        ],
    },
];

const ContactActions = {
    LOAD_DATA: "load-data",
};

function SearchFilterReducer(state, action) {
    if (action.type === FormActions.INPUT_CHANGED) {
        return { ...state, [action.payload.name]: action.payload.value };
    }
    if (action.type === ContactActions.LOAD_DATA) {
        return { ...action.payload, };
    }
    return state;
}

const SearchFilterDefaults = {
    Forename: "",
    Mobile: "",
    Position: "",
    Priority: 5,
    Surname: "",
    Telephone: ""
}